import { product } from 'texts/common';

const Copyright = () => {
  return <p className="footer-copyright">{product.copyright}</p>;
};

export default Copyright;
